import { render } from "./ContactService.vue?vue&type=template&id=fe8f98c4&scoped=true"
import script from "./ContactService.vue?vue&type=script&lang=js"
export * from "./ContactService.vue?vue&type=script&lang=js"

import "./ContactService.vue?vue&type=style&index=0&id=fe8f98c4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe8f98c4"]])

export default __exports__